import React from "react";
import costcoLoading from "../../../public/images/svg/loading.svg";

type MultiSelectProps = {
  options: { value: string; label: string }[];
  valueOfField: string[];
  handleCheckboxChange: (value: string) => void;
  isLoading?: boolean;
  isAll?: boolean;
};

const CheckboxList: React.FC<MultiSelectProps> = ({
  options,
  valueOfField,
  handleCheckboxChange,
  isLoading,
  isAll,
}) => {
  const failedToLoad = options.length === 0 && isLoading === false;
  const failedMessage = "Failed to fetch the options";
  const getCheckStatus = (value: string) =>
    valueOfField.includes(value.toLowerCase()) || isAll;
  return (
    <div>
      {isLoading && (
        <div className="text-center p-2" id="loading-spinner">
          <img src={costcoLoading} alt="Loading..." className="mx-auto" />
        </div>
      )}
      {failedToLoad && (
        <div className="text-center py-2 px-1 text-sm text-red-900 font-semibold">
          {failedMessage}
        </div>
      )}
      {options.length > 0 &&
        !isLoading &&
        options.map((op) => (
          <div
            key={op.value}
            className="px-2 pt-4 flex flex-row w-[72px] text-md overscroll-auto cursor-default"
          >
            <input
              type="checkbox"
              id={op.value}
              checked={getCheckStatus(op.value)}
              onChange={() => handleCheckboxChange(op.value)}
              className="accent-CostcoAction transition-all delay-300 ease-in-out cursor-pointer"
            />

            <label
              htmlFor={op.value}
              className="pl-3 text-gray-700 tracking-wider cursor-pointer select-none"
            >
              {op.label}
            </label>
          </div>
        ))}
    </div>
  );
};

export default CheckboxList;
